export default function CTASection() {
  return (
    <section id="download" style={{
      padding: '8rem clamp(1rem,4vw,3rem)',
      background: 'linear-gradient(135deg,var(--coral3) 0%,var(--coral) 40%,#E8824A 70%,var(--coral3) 100%)',
      backgroundSize: '400% 400%',
      animation: 'bgShift 8s ease infinite',
      textAlign: 'center', position: 'relative', overflow: 'hidden',
    }}>
      {/* Diagonal grid texture */}
      <div style={{
        position: 'absolute', inset: 0, opacity: 0.06, pointerEvents: 'none',
        backgroundImage: 'repeating-linear-gradient(45deg,#fff 0,#fff 1px,transparent 0,transparent 50%)',
        backgroundSize: '20px 20px',
      }} />

      {/* Decorative icons */}
      <div style={{ position: 'absolute', right: '-3%', top: '-8%', fontSize: 280, opacity: 0.05, transform: 'rotate(15deg)', pointerEvents: 'none', userSelect: 'none' }}>⚽</div>
      <div style={{ position: 'absolute', left: '-2%', bottom: '-8%', fontSize: 200, opacity: 0.05, transform: 'rotate(-10deg)', pointerEvents: 'none', userSelect: 'none' }}>🏟️</div>

      <div style={{ position: 'relative', zIndex: 2 }}>
        <p style={{ fontFamily: 'var(--font-m)', fontSize: 11, letterSpacing: 3, marginBottom: '1.5rem', opacity: 0.85, textTransform: 'uppercase' }}>
          Free · No Ads · No Pitch Markup · Just Football
        </p>

        <h2 style={{
          fontFamily: 'var(--font-d)', fontWeight: 900,
          fontSize: 'clamp(52px,7vw,90px)', textTransform: 'uppercase',
          lineHeight: 0.9, marginBottom: '2.5rem',
        }}>
          Download.<br />Organize.<br />Play.
        </h2>

        <p style={{ fontSize: 18, opacity: 0.9, marginBottom: '3rem', fontWeight: 300, maxWidth: 500, margin: '0 auto 3rem' }}>
          Built by players, for players in the UAE. Version 1.0 — Launch.
        </p>

        <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}>
          {['⬇ App Store', '⬇ Google Play'].map((label) => (
            <button key={label} className="shimmer-btn" style={{
              background: 'rgba(0,0,0,0.25)',
              border: '1px solid rgba(255,255,255,0.35)',
              fontFamily: 'var(--font-d)', fontSize: 16, fontWeight: 700,
              letterSpacing: 2, textTransform: 'uppercase', color: '#fff',
              padding: '16px 36px', borderRadius: 4,
            }}>{label}</button>
          ))}
        </div>
      </div>
    </section>
  );
}
